var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarningRed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 62,
    height: 62,
    rx: 20,
    fill: "#FBE8E8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5099_97563)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.9883 17C38.7233 16.9883 45.0117 23.265 45 31C45 38.7467 38.7583 44.9883 31.0117 45C23.2767 45.0117 16.9883 38.735 17 30.9883C17.0117 23.2533 23.2533 17.0117 30.9883 17ZM31.0117 19.7883C24.8633 19.7767 19.8117 24.805 19.7883 30.9883C19.765 37.1367 24.7933 42.1767 30.9767 42.2233C37.1133 42.27 42.2117 37.1833 42.2233 31.0117C42.2233 24.84 37.1833 19.8 31.0117 19.7883Z",
    fill: "#D81922"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.997 25.8724C32.8804 27.8091 32.7637 29.7224 32.647 31.6241C32.6237 31.9974 32.6354 32.3824 32.612 32.7558C32.5887 33.2574 32.3904 33.6658 31.912 33.8874C31.4687 34.0858 31.0604 34.0274 30.6754 33.7358C30.3604 33.4908 30.2554 33.1408 30.232 32.7674C30.127 30.8891 30.022 29.0108 29.917 27.1324C29.882 26.5724 29.7887 25.9891 29.8587 25.4408C29.9637 24.5074 30.6987 23.9358 31.527 24.0058C32.4254 24.0641 32.997 24.7291 32.997 25.6858C32.997 25.7558 32.997 25.8258 32.997 25.8724Z",
    fill: "#D81922"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8703 36.6525C29.8703 35.7891 30.582 35.0775 31.4453 35.0775C32.3087 35.0775 32.9853 35.7891 32.9737 36.6875C32.962 37.5275 32.262 38.2158 31.422 38.2158C30.5703 38.2041 29.8703 37.5158 29.8703 36.6525Z",
    fill: "#D81922"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5099_97563"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(17 17)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningRed);
export default __webpack_public_path__ + "static/media/warning-red.33ce4166438ce930d29649b8786f6e87.svg";
export { ForwardRef as ReactComponent };